import React, { Dispatch, SetStateAction } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../../components/organisms/Table';
import { weekDays } from './useCalendar';
import { CalendarDay } from './CalendarDay';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { CalendarDayInfoType, EventType, WeekDayAbbrType, WeekDayType } from '../../CalendarTypes';

type CalendarContentType = {
  title: string;
  tableId: string;
  eventListId: string;
  eventsToShow: EventType[];
  weekday: (day: string) => WeekDayType;
  getCalendarDayInfo: (position: number) => CalendarDayInfoType;
  getClassOfCalendarDay: (calendarDayInfo: CalendarDayInfoType) => any;
  setEventsToShow: Dispatch<SetStateAction<EventType[]>>;
  onClickEvent: (currentDate: string) => void;
};

export function CalendarContent({
  title,
  tableId,
  eventListId,
  eventsToShow,
  weekday,
  getCalendarDayInfo,
  getClassOfCalendarDay,
  setEventsToShow,
  onClickEvent,

}: CalendarContentType) {
  const { t } = useSonTranslation('Calendar');

  const tableRows = [];
  for (let row = 0; row < 6; row += 1) {
    const weekDayComponents = [];
    for (let weekDay = 1; weekDay < 8; weekDay += 1) {
      weekDayComponents.push(
        <CalendarDay
          key={`${row}${weekDay}`}
          weekDay={weekDay}
          row={row}
          getCalendarDayInfo={getCalendarDayInfo}
          eventsToShow={eventsToShow}
          getClassOfCalendarDay={getClassOfCalendarDay}
          setEventsToShow={setEventsToShow}
          onClickEvent={onClickEvent}
          eventListId={eventListId}
        />,
      );
    }
    tableRows.push(
      <TableRow key={row} className="calendar__table-row">
        {weekDayComponents}
      </TableRow>,
    );
  }

  return (
    <div className="calendar__content">
      <Table caption={title} customTableClass="calendar__table" id={tableId}>
        <TableHead customTableHeadClass="calendar__table-head">
          <TableRow className="calendar__table-row">
            {weekDays.map((weekDay: WeekDayAbbrType) => (
              <TableCell key={weekDay} customTableHeaderClass="calendar__tableheader font-regular-13-13">
                <span aria-hidden="true">{t(`weekDaysAbbreviation.${weekDay}`)}</span>
                <span className="invisible">{t(`weekDays.${weekday(weekDay)}`)}</span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody className="calendar__table-body">{tableRows}</TableBody>
      </Table>
    </div>
  );
}
